/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBcAdditionalShipToViewProps } from './bc-additional-ship-to-info';

export default (props: IBcAdditionalShipToViewProps) => {
    return (
        <div className='row'>
            {props.input}
            {props.additionalShipToInfo}
        </div>
    );
};
